import { globalRef, logDebug, onLine, requestWithRetry } from '@amazon/vinyl-util'
import { CacheManager } from '@amazon/vinyl-cache-manager'
import { ctx } from '@/util/context'

const { target } = ctx('dynamicCache')

export const cacheManagerRef = globalRef(
    () =>
        new CacheManager({
            requestFromNetwork: requestWithRetry,
        })
)

export function getCacheManager(): CacheManager {
    return cacheManagerRef.value
}

/**
 * Removes old cache entries that have passed their TTL.
 */
export async function cleanCache() {
    if (onLine()) {
        logDebug(target, 'purging stale cache items')
        await getCacheManager().clean()
    }
}
